import React, { useEffect, useState } from 'react'
import Land from '../../Assets/images/land.png'
import Bank from '../../Assets/images/bankk.png'
import InvestComp from './InvestComp'
import InvestCom from './InvestCom'
import { Link } from 'react-router-dom'
import getServices from '../../Services/get-service'
import { toast } from 'react-toastify'
import House from '../../Assets/images/house.png'

const getSoldPercentage = ({ totalUnitsAvailable, unitsRemaining }) => {
  if (
    !Number.isFinite(totalUnitsAvailable) ||
    totalUnitsAvailable <= 0 ||
    !Number.isFinite(unitsRemaining)
  ) {
    return null;
  }

  return Math.min(
    100,
    Math.max(0, ((totalUnitsAvailable - unitsRemaining) / totalUnitsAvailable) * 100),
  );
};

function MakeInvestment() {
  const [projects, setProjects] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false;

    const fetchTopInvestments = async () => {
      try {
        const response = await getServices.getTopInvestment();
        if (cancelled) return;

        const result = response.data;
        if (result?.statusCode !== 200) {
          throw new Error(result?.description || 'Unable to load top investments.');
        }

        const investments = result.data?.topInvestment;
        if (!Array.isArray(investments)) {
          throw new Error('Unable to load top investments.');
        }

        const seenIds = new Set();
        const uniqueInvestments = investments.filter((investment) => {
          if (investment?.id == null || seenIds.has(investment.id)) return false;
          seenIds.add(investment.id);
          return true;
        });

        // Preview two investments
        setProjects(uniqueInvestments.slice(0, 2));
      } catch (error) {
        if (cancelled) return;
        setProjects([]);
        toast.error(
          error?.response?.data?.description ||
            error?.message ||
            'Unable to load top investments.',
        );
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    fetchTopInvestments();
    return () => {
      cancelled = true;
    };
  }, [])

  return (
    <>
      <div className="rounded-lg border border-[#D2D3D5] p-4">
        <p className="my-3 text-[#808285] text-[14px]">Make a new investment</p>

        <div className="my-5 grid md:grid-cols-2 gap-4">
          <InvestComp
            img={Land}
            title="Land banking"
            sub="Join other investors to raise funds for projects and earn ROI based on your investment."
            color="bg-[#FDEAD2] border-[#FCDBB4]"
          />
          <InvestComp
            img={Bank}
            title="Property banking"
            sub="Join other investors to raise funds for projects and earn ROI based on your investment."
            color="bg-[#CCF2E1] border-[#AAE9CC]"
          />
        </div>
        <div>
          <div className="mb-4 flex justify-between">
            <p className="text-[#808285] text-[16px]">Top investments</p>
            <Link
              to="/buy"
              className="pb-2 border-b border-b-primary-color text-[14px] text-primary-color"
            >
              Go to investments
            </Link>
          </div>

          <div className="mt-4 grid md:grid-cols-2 gap-3">
            {loading ? (
              [1, 2].map((item) => (
                <div key={item}>
                  <InvestCom componentLoading={true} />
                </div>
              ))
            ) : projects.length > 0 ? (
              projects.map((project) => {
                const percentageSold = getSoldPercentage(project);

                return (
                  <div key={project.id}>
                    <InvestCom
                      link={`/buy`}
                      img={project.imageUrl || House}
                      percentage={percentageSold ?? 0}
                      per={percentageSold == null ? null : Math.floor(percentageSold)}
                      name={project.title}
                      state={project.locality}
                      target={project.price}
                      raised={project.investmentCumulative}
                    />
                  </div>
                );
              })
            ) : (
              <div className="col-span-full flex flex-col items-center justify-center py-10">
                <p className="text-center text-[#808285]">
                  No Top Investment yet
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default MakeInvestment
